import { render, staticRenderFns } from "./ErrorList.vue?vue&type=template&id=13c6ef07&scoped=true&"
import script from "./ErrorList.vue?vue&type=script&lang=ts&"
export * from "./ErrorList.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorList.vue?vue&type=style&index=0&id=13c6ef07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c6ef07",
  null
  
)

export default component.exports